import {
    TranslocoMissingHandler,
    TranslocoMissingHandlerData,
} from '@jsverse/transloco';
export class CustomHandler implements TranslocoMissingHandler {
    handle(_key: string, _data: TranslocoMissingHandlerData): any {
        // if (!environment?.production) {
        //     console.warn(`Translation for ${key} was not found in ${data.activeLang}`);
        // }
        return null;
    }
}
